export default "__VITE_ASSET___dYUxXqd__"